// Live Available Shifts - GetLiveAvailableShiftsWithPagination
export const FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST = 'FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST';
export const FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS = 'FETCH_LIVE_AVAILABLE_SHIFTS_SUCCESS';
export const FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE = 'FETCH_LIVE_AVAILABLE_SHIFTS_FAILURE';

// Legend Table Data
export const FETCH_LEGEND_TABLE_DATA_REQUEST = 'FETCH_LEGEND_TABLE_DATA_REQUEST';   
export const FETCH_LEGEND_TABLE_DATA_SUCCESS = 'FETCH_LEGEND_TABLE_DATA_SUCCESS';
export const FETCH_LEGEND_TABLE_DATA_FAILURE = 'FETCH_LEGEND_TABLE_DATA_FAILURE';